import { HttpInterceptorFn, HttpRequest, HttpHandlerFn, HttpEvent, HttpResponse, HttpErrorResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { tap, finalize } from 'rxjs/operators';
import { inject } from '@angular/core';
import { NewRelicService } from '../services/newRelic.service';


export const newRelicInterceptor: HttpInterceptorFn = (req: HttpRequest<any>, next: HttpHandlerFn): Observable<HttpEvent<any>> => {
  const newRelicService = inject(NewRelicService);
  const startTime = Date.now();

  return next(req).pipe(
    tap(
      (event: HttpEvent<any>) => {
        if (event instanceof HttpResponse) {
          const duration = Date.now() - startTime;

          newRelicService.addPageAction('API_CALL_SUCCESS', {
            method: req.method,
            url: req.url,
            status: event.status,
            duration: duration
          });
        }
      },
      (error: HttpErrorResponse) => {
        const duration = Date.now() - startTime;
        newRelicService.noticeError(new Error(`HTTP ${error.status}: ${error.message}`), {
          method: req.method,
          url: req.url,
          status: error.status,
          duration: duration,
          errorType: 'HTTP_ERROR'
        });

        newRelicService.addPageAction('API_CALL_ERROR', {
          method: req.method,
          url: req.url,
          status: error.status,
          duration: duration,
          error: error.message
        });
      }
    )
  );
};